import { MobilyOTPLineAction } from '../actions/MobilyOTPLineAction'
import { SequenceManagerAction } from "../actions/SequenceManagerAction";

const initState = {
    requestBody: {
        sectionId: "MobilyOTPLine",
            steps: [
                {
                    sequence: "0",
                    stepId: "MobilyOTPLine",
                    offerContainerId: "",
                    fields: [
                        {
                            name: "MSISDN",
                            value: ""
                        }
                    ]
                }
            ]
    },
  }
  
  const MobilyOTPLineReducer = (state: any = initState, action: any) => {
    const { type } = action;
    const { payload } = action;
    var mobilyOtpValue = { ...state.requestBody.steps };
  
    switch (type) {
      case MobilyOTPLineAction.MOBILY_OTP_MAKE_SELECTION:
        mobilyOtpValue[0].fields[0].value = payload.selection;
        mobilyOtpValue[0].offerContainerId = payload.offerContainerId;
        return state;
  
      case SequenceManagerAction.GET_CHECKOUT_SUCCESS:
        let section = payload.sections.filter((section: any) => {
          return (section.sectionId === 'MobilyOTPLine')
        });
        if (section.length > 0) {
          let numberTypeValue = section[0].steps[0].fields[0];
          mobilyOtpValue[0].offerContainerId = section[0].steps[0].offerContainerId;
          mobilyOtpValue[0].fields[0].value = numberTypeValue ? numberTypeValue.value : "";
        }
        return state;
  
      default:
        return state;
    }
  }
  
  export default MobilyOTPLineReducer;